module.exports = __webpack_public_path__ + "c9ae7af8b1f28c89a3ba37dd73900c12.jpg";